import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { JwtHelper } from '../../helpers/jwtDecode.helper';
import { UsuarioAllProperties } from '../../models/usuarioAllProperties.model';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast.service';
import { SeveridadeToast } from '../../models/enums/severidade-toast.enum';

@Component({
    selector: 'app-toolbar-search',
    standalone: true,
    imports: [
        CommonModule,
        InputTextModule,
        ToolbarModule,
        FormsModule,
        CalendarModule,
        ButtonModule
    ],
    templateUrl: './toolbarSearch.component.html',
    styleUrl: './toolbarSearch.component.scss'
})
export class ToolbarSearchComponent {

    private userId: string;
    usuario: UsuarioAllProperties;
    dataCriacaoUsuario: Date;

    @Input() placeholder: string = 'Pesquisar';
    @Input() showLeftGroup: boolean = true;
    @Input() showSearchInput: boolean = true;
    @Input() showDownloadButton: boolean = false;
    @Input() showDateFilters: boolean = false;
    @Input() showSingleDate: boolean = false;
    @Input() dataInicio: Date | null = null;
    @Input() dataFim: Date | null = null;
    @Input() date: Date | Date[] | null = null;
    @Input() minDate: Date;

    @Output() onSearch = new EventEmitter<string>();
    @Output() onDownload = new EventEmitter<void>();
    @Output() onDateChange = new EventEmitter<void>();
    @Output() dataInicioChange = new EventEmitter<Date>();
    @Output() dataFimChange = new EventEmitter<Date>();
    @Output() dateChange = new EventEmitter<Date | Date[]>();

    constructor(
        private jwtHelper: JwtHelper,
        private authService: AuthService,
        private toastService: ToastService,
    ) {
        this.userId = this.jwtHelper.getUserIdFromToken();
    }

    ngOnInit() {
        this.retornaTodasPropriedadesUsuario(this.userId);
        this.minDate = new Date();
    }

    retornaTodasPropriedadesUsuario(userId: string) {
        this.authService.obterUsuarioAllPropertiesPorId(userId).subscribe({
            next: (res) => {
                this.usuario = res;
                this.retornaDataCriacaoUsuario(this.usuario)
            },
            error: (e) => {
                this.toastService.setMensagemToast(`Erro ao obter usuário.`, SeveridadeToast.Error);
            }
        })
    }

    retornaDataCriacaoUsuario(usuario: UsuarioAllProperties) {
        const raw = usuario.createdAt;
        if (!raw) {
            this.toastService.setMensagemToast(
                'Não foi possível obter a data de criação da conta.',
                SeveridadeToast.Error
            );
            this.dataCriacaoUsuario = new Date();
            return;
        }
        const fullDate = new Date(raw);
        this.dataCriacaoUsuario = new Date(fullDate.getFullYear(), fullDate.getMonth(), fullDate.getDate());
    }

    applySearch(event: Event): void {
        const input = event.target as HTMLInputElement;
        const filterValue = input.value;
        this.onSearch.emit(filterValue);
    }

    onDateSelect(): void {
        if (this.showSingleDate) {
            this.dateChange.emit(this.date);
        } else {
            this.dataInicioChange.emit(this.dataInicio);
            this.dataFimChange.emit(this.dataFim);
        }
        this.onDateChange.emit();
    }

    downloadExcel(): void {
        this.onDownload.emit();
    }
}